import { render, staticRenderFns } from "./AddFaturaPage.vue?vue&type=template&id=13e424c5&"
import script from "./AddFaturaPage.vue?vue&type=script&lang=js&"
export * from "./AddFaturaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports